import actionTypes from './navigation.actionTypes';

const initialNavigationState = {
    isDrawerMenuVisible: false
};

export function navigation(state = initialNavigationState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.DISPLAY_DRAWER_MENU:
            Object.assign(nextState, state, {
                isDrawerMenuVisible: action.visible
            });
            break;
        default:
            nextState = state;
    }
    return nextState;
}

const initialTenantsState = {
    isFetching: false,
    data: {}
};

export function tenants(state = initialTenantsState, action) {
    let nextState = {};
    switch(action.type) {
        case actionTypes.REQUEST_CLIENTS:
            Object.assign(nextState, state, {
               isFetching: true 
            });
            break;
        case actionTypes.RECEIVE_CLIENTS_SUCCESS: {
            Object.assign(nextState, state, {
                isFetching: false,
                lastUpdated: action.receivedAt,
                data: action.data.sort(sortByName)
            });
            break;
        }
        default:
            nextState = state;
    }
    return nextState;
}

const sortByName = (tenantOne, tenantTwo) => {
    return tenantOne.name.localeCompare(tenantTwo.name);
};